const styles = () => ({
    root: {
        minWidth: 55,
    },
});

export default styles;
